import { Component, Injector } from '@angular/core';
import { ServiceListings, ServiceDatastore, ServiceTextAnalyser } from '@services';
import { AbstractFilterByChipComponent } from '../abstract-filters-by-chip.component';

@Component({
    selector: 'filters-by-creator',
    templateUrl: './filters-by-creator.component.html',
    styleUrls: ['./filters-by-creator.component.scss']
})
export class FiltersByCreatorComponent extends AbstractFilterByChipComponent {
    constructor(
        injector: Injector,
        serviceDatastore: ServiceDatastore,
        textAnalyserService: ServiceTextAnalyser
    ) {
        super(injector, serviceDatastore, textAnalyserService, 'creators', 'creators');
    }
}
